module.exports = __webpack_public_path__ + "img/type-1.6496e15c.png";